// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__n4W4J","text":"SelectPayment_text__2U6bB","title":"SelectPayment_title__2TnWz","btn":"SelectPayment_btn__3oGRd"};